<template>
  <div class="santander-slider">
    <div class="santander-slider__panel">
      <p class="santander-slider__title">{{ title }}</p>
      <p class="santander-slider__value">
        {{ thousandSeparator(modelValue) }} {{ postfix }}
      </p>
    </div>
    <VueSlider
      v-model="internalValue"
      :dot-size="30"
      :max="max"
      :min="min"
      :interval="interval"
      :clickable="false"
      @drag-end="$emit('drag-end')"
    ></VueSlider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import { thousandSeparator } from '@/functions'

export default {
  props: {
    postfix: { default: null, type: String },
    title: { default: null, type: String },
    modelValue: { default: null, type: Number },
    min: { default: 0, type: Number },
    max: { default: 1000, type: Number },
    interval: { default: 1, type: Number },
  },
  data() {
    return {
      internalValue: null,
    }
  },
  components: {
    VueSlider,
  },
  watch: {
    internalValue(newValue) {
      this.$emit('update:modelValue', newValue)
    },
  },
  created() {
    this.internalValue = this.modelValue
  },
  methods: {
    thousandSeparator(value) {
      return thousandSeparator(value)
    },
  },
}
</script>

<style lang="scss">
@import 'SantanderSlider.scss';
@import '../Search/Slider/VueSlider.scss';
</style>
